var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { generateBase64Source } from '@src/components/icon';
import tiktok from '@bridge/tiktok';
import { initialPageProps, loadPageCb, tryRedirectLynx } from '@src/lib/load_page';
import { I18n } from '@ies/starling_intl';
import { loadI18n } from '@src/lib/starling';
import { TUXAppBar, TUXButton, TUXDialog, TUXProvider, TUXStatusViewFixedHeightLayoutWIP, TUXStatusViewWIP, } from '@byted-tiktok/tux-components';
import '@byted-tiktok/tux-components/dist/index.css';
import { appVersion, isIOS, isTiktok } from '@src/lib/env_detect';
var Maintenance = /** @class */ (function (_super) {
    __extends(Maintenance, _super);
    function Maintenance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initPageProps = initialPageProps(_this.props || {});
        _this.state = {
            I18nLoaded: false,
            showUpdateDialog: appVersion < 220100,
        };
        _this.fetchI18n = function () { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadI18n()];
                    case 1:
                        _a.sent();
                        this.setState({
                            I18nLoaded: true,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.close = function () {
            tiktok.app.close();
        };
        _this.handleUpdateDialogDismiss = function () {
            _this.setState({ showUpdateDialog: false });
        };
        _this.handleUpdateDialogConfirm = function () {
            // 应用商店唤起
            if (isIOS) {
                tiktok.bridge.call('download_click', {
                    direct_download: true,
                    app_id: isTiktok ? '1235601864' : '835599320',
                });
            }
            else {
                var pkg_name_1 = isTiktok ? 'com.ss.android.ugc.trill' : 'com.zhiliaoapp.musically';
                tiktok.bridge.call('download_click', {
                    app_id: pkg_name_1,
                }, function (res) {
                    if (res.code === -2) {
                        window.open("market://detail?id=" + pkg_name_1, '_system');
                    }
                });
                setTimeout(function () {
                    window.location.href = "http://play.google.com/store/apps/details?id=" + pkg_name_1;
                }, 1000);
            }
        };
        return _this;
    }
    Maintenance.prototype.componentDidMount = function () {
        this.fetchI18n();
        loadPageCb(this.initPageProps);
    };
    Maintenance.prototype.render = function () {
        var _a = this.state, I18nLoaded = _a.I18nLoaded, showUpdateDialog = _a.showUpdateDialog;
        if (!I18nLoaded) {
            return null;
        }
        return (React.createElement(TUXProvider, { theme: "light" },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    marginRight: '32px',
                    marginLeft: '32px',
                } },
                React.createElement(TUXAppBar, { title: "", startActions: {
                        actionVariant: 'back',
                        onClick: this.close,
                    } }),
                React.createElement(TUXStatusViewFixedHeightLayoutWIP, { statusView: React.createElement(TUXStatusViewWIP, { image: {
                            variant: 'banner',
                            src: generateBase64Source('maintenance').uri,
                        }, title: I18n.t('promote_emergency_cutoff_title'), message: I18n.t('promote_emergency_cutoff_content') }), button: React.createElement(TUXButton, { text: I18n.t('Promote_Retry'), size: "large", variant: "secondary", onClick: tryRedirectLynx, maxWidth: 200 }), imageVariant: "banner" }),
                React.createElement(TUXDialog, { isVisible: showUpdateDialog, title: I18n.t('Promote_Notice_Title'), message: I18n.t('promote_appversion_upgrade_reminder'), onDismiss: this.handleUpdateDialogDismiss, actionVariant: "button", actions: [
                        {
                            variant: 'primary',
                            text: I18n.t('promote_appversion_upgrade_upgrade_button'),
                            onClick: this.handleUpdateDialogConfirm,
                        },
                        {
                            variant: 'secondary',
                            text: I18n.t('promote_appversion_upgrade_skip_button'),
                            onClick: this.handleUpdateDialogDismiss,
                        },
                    ] }))));
    };
    return Maintenance;
}(React.Component));
export default Maintenance;
